export default function PublishedWorks() {
  const books = [
    {
      title: 'Gen 1',
      year: '2024',
      genre: 'Religious Studies',
      status: 'Available Now',
      featured: true,
      description: 'This is for all those who are unable to find the time to actually read the entire Bible. I\'ve done it for you and condensed the plot into a 1 to 4 hour read. Hope you enjoy!',
      amazonLink: 'https://www.amazon.com/Gen-1-Richard-Pontefract/dp/1967361444',
      image: 'https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/55b6a42b0ea2865e6f74ded7214c0195.jpeg'
    }
  ];

  return (
    <section id="works" className="py-32 px-20 bg-[#ECECEC]">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-20">
          <h2 className="text-7xl font-bold text-[#2C2C2C]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Published Works
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-md text-right">
            Making the Bible accessible through thoughtful condensation
          </p>
        </div>

        <div className="grid grid-cols-1 gap-10 max-w-2xl mx-auto">
          {books.map((book, index) => (
            <div 
              key={index}
              className="bg-[#2C2C2C] rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-2xl"
            >
              <div className="p-12">
                {book.status && (
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#C9A961] rounded-full mb-6">
                    <i className="ri-star-fill text-white text-sm"></i>
                    <span className="text-xs text-white font-medium whitespace-nowrap">{book.status}</span>
                  </div>
                )}
                <h3 className="text-5xl font-bold mb-3 text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {book.title}
                </h3>
                <p className="text-sm mb-8 text-white/70">
                  {book.year} • {book.genre}
                </p>
                
                <div className="grid grid-cols-2 gap-8 mb-8">
                  <div className="w-full h-[500px]">
                    <img 
                      src={book.image}
                      alt={book.title}
                      className="w-full h-full object-cover rounded-2xl shadow-lg"
                    />
                  </div>
                  <div className="flex flex-col justify-center">
                    <h4 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                      About the Book
                    </h4>
                    <p className="text-lg text-white/90 leading-relaxed mb-8" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.8' }}>
                      {book.description}
                    </p>
                    <div className="space-y-4">
                      <a 
                        href={book.amazonLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full py-4 rounded-full font-medium transition-all duration-300 whitespace-nowrap bg-[#C9A961] text-white hover:bg-[#B89851] text-center"
                      >
                        Buy on Amazon
                        <i className="ri-amazon-line ml-2"></i>
                      </a>
                      <button className="w-full py-4 rounded-full font-medium transition-all duration-300 whitespace-nowrap bg-[#1A2332] text-white hover:bg-[#1A2332]/80">
                        Read Excerpt
                        <i className="ri-arrow-right-line ml-2"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>1-4</div>
                    <div className="text-sm text-white/70">Hours to Read</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Full</div>
                    <div className="text-sm text-white/70">Bible Coverage</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>30+</div>
                    <div className="text-sm text-white/70">Years Research</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
